import React from 'react';
import {_GPY,__GPYPost} from '../../../env.js'
import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyTime from '../lib/GpyTime.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyTeamList from '../lib/GpyTeamList.js';
import GpyCoachList from '../lib/GpyCoachList.js';
import GpyGameLog from '../lib/GpyGameLog.js';

import OBSOLATE_GameScoreBoard from '../OBSOLATE_GameScoreBoard.js';
import Display from '../../display/Display.js';
import WaitCube from '../../../WaitCube'

import moment from 'moment';
import 'moment/locale/de';

import OBS from '../../OBS.js'
import Casper from '../../Casper.js'

class SBSoccerFootball extends OBSOLATE_GameScoreBoard {

		constructor(props) {
			super(props);
			this.state = super.getGPYState("SoccerFootball");
		}

		componentDidMount() {
	 		super.getGamesStates();
		 	super.getGames();
		 	super.getAdvertisements();
		 	super.getLayouts();
	  }

    reset() {
			super.onPlayTime(this.state.NAME+"_gameclock","stop");
			super.onPlayTime(this.state.NAME+"_countdown","stop");
			super.setGameTime(this.state.NAME+"_gameclock",0);
			super.setGameTime(this.state.NAME+"_countdown",0);
			super.reset();
		}


	 render () {
		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";

    return (
			<div>

					<div className="row justify-content-end">
						<div className="col-6 text-left p-0"><button onClick={()=>{super.doChangeValue({},"OBS","toggleOBSPanel");}} className="btn btn-link"><img style={{maxWidth : '18px', maxHeight : '18px'}} src={_GPY.resource(this.state.components.OBS!==undefined&&this.state.components.OBS.state.showOBSPanel===true?"images/obs_green.png":"images/obs_black.png")} className="img-fluid" alt=""/></button></div>
						<div className="col-6 text-right"><button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target={"#gametype_"+this.state.NAME+"_scoreboard_games"} aria-expanded="false" aria-controls={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<span className="text-secondary">
						<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>&nbsp;
						{this.state.currentGame.id > 0 ? this.state.currentGame.gameName + " - " + moment(this.state.currentGame.startTime).locale('de').format('L') + " (" + moment(this.state.currentGame.startTime).locale(_GPY.locale).format('HH:mm') + "-"+  moment(this.state.currentGame.endTime).locale(_GPY.locale).format('HH:mm')+ ")":_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}
						&nbsp;<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>
						</span>
						</button></div>
					</div>

					<div className="collapse bg-light" id={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<div className="row justify-content-center pt-4">
							  {this.state.gamesIsLoaded && this.state.games.Games.Game.length>0?
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}</h3></div>
								:
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_nogame_title')}</h3></div>
								}

								<div className="col-12 col-sm-12 col-md-8 col-xl-8">
									<div className="list-group">
										 {this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {

											 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {

												return (
												<button key={t.id} onClick={()=> {super.onSelectGame(t.id,this.reset())}} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
													<div className="row p-2">
													<div className="col-2"><img style={{maxWidth : '50px',maxHeight : '50px'}} src={t.teams.Team[0]!==undefined&&t.teams.Team[0].logo!==undefined&&t.teams.Team[0].logo!==""?_GPY.resource("upload/" + t.teams.Team[0].logo):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="Guppyi Logo"/></div>
													<div className="col-8 text-center"><span>{t.gameName} - {moment(t.startTime).locale('de').format('L')}  ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</span></div>
													<div className="col-2 text-right"><img style={{maxWidth : '50px',maxHeight : '50px'}} src={t.teams.Team[1]!==undefined&&t.teams.Team[1].logo!==undefined&&t.teams.Team[1].logo!==""?_GPY.resource("upload/" + t.teams.Team[1].logo):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="Guppyi Logo"/></div>
													</div>
											  </button>);
											} else {
												return "";
											}

										 })  : "" }
									</div>
								</div>
            </div>
						<div className="row p-4">
							<div className="col border-top"></div>
							<div className="col-1 text-center text-muted"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/></div>
							<div className="col border-top"></div>
						</div>
				</div>



			<OBS className="mb-2" scoreboard={this}
					 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
					 getGameId={() => {return this.state.currentGame.id}} />

		  <Casper className="mb-2" scoreboard={this}
				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
				 getGameId={() => {return this.state.currentGame.id}} />

			{this.state.currentGame.id > 0 ?

			<div className="row">
				<div className="col-6 pl-4" style={{maxWidth:(this.state.displayWidth+10)+"px"}}>

				 <div className="row">
				 			<div className="col-9 p-0 border border">
				 		  <select className="form-control"  style={{zIndex:100}} onChange={super.changeLayout.bind(this)} value={this.state.currentLayout.id}>
								<option key="-1" value="-1">default</option>
								{this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
									<option key={t.id} value={t.id}>{t.name}</option>
								):""}
				 			</select>
							</div>
							<div className="col-3 p-0 border border">
								<button className="btn btn-outline-dark btn-block" onClick={this.reset.bind(this)}>Reset</button>
							</div>
							<div className="col-12 p-0 border border-white" style={{backgroundColor:"#ff6"}}>
									<Display onData={(data,key)=>{super.onData(key,data);}} width={this.state.displayWidth} height={Math.round(this.state.displayWidth/1.7777777778)} layoutId={this.state.currentLayout.id} stateName="__DISPLAY__" scoreboard={this}/>
							</div>
				</div>


			<div className="row border border-secondary rounded">
			  	  <div className="col-12 p-1"><strong>Score</strong></div>
						<div className="col-5 p-1"><GpyScoreButton min="0" max="300" stateName="SoccerFootball_score_home" scoreboard={this}
																			getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
																			getGameId={() => {return this.state.currentGame.id} }
																	 /></div>
						<div className="col-2"><p className="text-center">VS</p></div>
						<div className="col-5"><GpyScoreButton min="0" max="300" stateName="SoccerFootball_score_guest" scoreboard={this}
																		getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
																		getGameId={() => {return this.state.currentGame.id} }
																	/></div>

																	 <div className="col-4 p-1">

			 																<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_goal_home_button')}
			 																	onInit={() => {return {}}}
			 																	onDeactivate={() => {return {visible: false}}}
			 																	onActivate={() => {
			 																		this.state.components['SoccerFootball_score_home'].incrementScore();

			 																		var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
			 																		var minF = (m/1000) / 60 ;
			 																		var min = Math.floor(minF) ;
			 																		var sec = Math.floor((minF-min)*60);

			 																		var formatMin = ('00'+min).slice(-2);
			 																		var formatSec = ('00'+sec).slice(-2);

			 																		return {visible: true,
			 																			playerName : this.state.currentGame.teamMap.HOME_TEAM.name,
			 																			player: {id:-1, firstName:"", lastName: this.state.currentGame.teamMap.HOME_TEAM.name, numOrPos:"", playerId:"", vsRole:"HOME_TEAM_PLAYER", profileImage: "default_avatar.png"},
			 																			team: this.state.currentGame.teamMap.HOME_TEAM,
			 																			time: this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0,
			 																			minute: formatMin,
																						second: formatSec,
			 																		}}}
			 																	scoreboard={this}
			 																	getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
			 																	getGameId={() => {return this.state.currentGame.id} }
			 																	stateName="SoccerFootball_button_goal_home"
			 																	autoexpirytime="15" />

																	 </div>


																	 <div className="col-4 p-1">

																	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_goal_player_button')}
																				condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER")===1)}}

																			 onInit={() => {return {}}}
																			 onDeactivate={() => {return {visible: false}}}

																			 onActivate={() => {

																				 if(this.state.selectedPlayers['HOME_TEAM_PLAYER'] !== undefined || this.state.selectedPlayers['HOME_TEAM_SUBSTITUE'] !== undefined){
																								this.state.components['SoccerFootball_score_home'].incrementScore();
																				 }
																				 if(this.state.selectedPlayers['GUEST_TEAM_PLAYER'] !== undefined || this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'] !== undefined){
																					  		 this.state.components['SoccerFootball_score_guest'].incrementScore();
																				 }

																				 var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
																				 var minF = (m/1000) / 60 ;
																				 var min = Math.floor(minF) ;
																				 var sec = Math.floor((minF-min)*60);

																				 var formatMin = ('00'+min).slice(-2);
																				 var formatSec = ('00'+sec).slice(-2);

																				 var p = this.state.selectedPlayers[Object.keys(this.state.selectedPlayers)[0]];
																				 return {visible: true,
																					 playerName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
																					 player:p,
																					 team: super.getTeamByPlayer(p),
																					 time: this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0,
																					 minute: formatMin,
																					 second: formatSec,
																				 }}}
																			 scoreboard={this}
																			 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
																			 getGameId={() => {return this.state.currentGame.id} }
																			 stateName="SoccerFootball_button_goal_player"
																			 autoexpirytime="15" />

																	 </div>
																	 <div className="col-4 p-1">
																	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_goal_guest_button')}
																		 onInit={() => {return {}}}
																		 onDeactivate={() => {return {visible: false}}}
																		 onActivate={() => {
																			 this.state.components['SoccerFootball_score_guest'].incrementScore();

																			 var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
																			 var minF = (m/1000) / 60 ;
																			 var min = Math.floor(minF) ;
																			 var sec = Math.floor((minF-min)*60);

																			 var formatMin = ('00'+min).slice(-2);
																			 var formatSec = ('00'+sec).slice(-2);
																			 return {visible: true,
																				 playerName : this.state.currentGame.teamMap.GUEST_TEAM.name,
																				 player: {id:-1, firstName:"", lastName: this.state.currentGame.teamMap.GUEST_TEAM.name, numOrPos:"", playerId:"", vsRole:"GUEST_TEAM_PLAYER", profileImage: "default_avatar.png"},
																				 team: this.state.currentGame.teamMap.GUEST_TEAM,
																				 time: this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0,
																				 minute: formatMin,
																				 second: formatSec,
																			 }}}
																		 scoreboard={this}
																		 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
																		 getGameId={() => {return this.state.currentGame.id} }
																		 stateName="SoccerFootball_button_goal_guest"
																		 autoexpirytime="15"/>

																	 </div>


					</div>

					<div className="row">
							<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_highlights_home_title')}</strong></div>
							<div className="col p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_highlight')}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {return {
										visible: true, type: "highlight", team:this.state.currentGame.teamMap.HOME_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_highlight')}}}
									getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
									getGameId={() => {return this.state.currentGame.id} }
									scoreboard={this}
									stateName="SoccerFootball_highlights_button_home_highlight"
									autoexpirytime="3"/>
							</div>

							<div className="col p-1">
							<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_corner')}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {return {visible: true, type:"corner", team:this.state.currentGame.teamMap.HOME_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_corner')}}}
								scoreboard={this}
								getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
								getGameId={() => {return this.state.currentGame.id} }
								stateName="SoccerFootball_highlights_button_home_corner"
								autoexpirytime="3"/>
							</div>

							<div className="col p-1">
							<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_offside')}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {return {visible: true,  type:"offside", team:this.state.currentGame.teamMap.HOME_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_offside')}}}
								scoreboard={this}
								getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
								getGameId={() => {return this.state.currentGame.id} }
								stateName="SoccerFootball_highlights_button_home_offside"
								autoexpirytime="3"/>
							</div>
							<div className="col p-1">
							<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_freekick')}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {return {visible: true, type:"freekick", team:this.state.currentGame.teamMap.HOME_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_freekick')}}}
								scoreboard={this}
								getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
								getGameId={() => {return this.state.currentGame.id} }
								stateName="SoccerFootball_highlights_button_home_freekick"
								autoexpirytime="3"/>
							</div>
							<div className="col p-1">
							<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_penalty')}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {return {visible: true, type:"penalty", team:this.state.currentGame.teamMap.HOME_TEAM ,message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_penalty')}}}
								scoreboard={this}
								getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
								getGameId={() => {return this.state.currentGame.id} }
								stateName="SoccerFootball_highlights_button_home_penalty"
								autoexpirytime="3"/>
							</div>
					</div>
					<div className="row">
						<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_highlights_guest_title')}</strong></div>
						<div className="col p-1">
							<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_highlight')}
								onDeactivate={() => {return {visible: false}}}
								onActivate={() => {return {visible: true, type:"highlight", team:this.state.currentGame.teamMap.GUEST_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_highlight')}}}
								scoreboard={this}
								getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
								getGameId={() => {return this.state.currentGame.id} }
								stateName="SoccerFootball_highlights_button_guest_highlight"
								autoexpirytime="3"/>
						</div>

						<div className="col p-1">
						<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_corner')}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {visible: true, type:"corner", team:this.state.currentGame.teamMap.GUEST_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_corner')}}}
							scoreboard={this}
							getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
							getGameId={() => {return this.state.currentGame.id} }
							stateName="SoccerFootball_highlights_button_guest_corner"
							autoexpirytime="3"/>
						</div>

						<div className="col p-1">
						<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_offside')}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {visible: true, type:"offside", team:this.state.currentGame.teamMap.GUEST_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_offside')}}}
							scoreboard={this}
							getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
							getGameId={() => {return this.state.currentGame.id} }
							stateName="SoccerFootball_highlights_button_guest_offside"
							autoexpirytime="3"/>
						</div>
						<div className="col p-1">
						<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_freekick')}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {visible: true, type:"freekick", team:this.state.currentGame.teamMap.GUEST_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_freekick')}}}
							scoreboard={this}
							getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
							getGameId={() => {return this.state.currentGame.id} }
							stateName="SoccerFootball_highlights_button_guest_freekick"
							autoexpirytime="3"/>
						</div>
						<div className="col p-1">
						<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_penalty')}
							onDeactivate={() => {return {visible: false}}}
							onActivate={() => {return {visible: true, type:"penalty", team:this.state.currentGame.teamMap.GUEST_TEAM , message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_penalty')}}}
							scoreboard={this}
							getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
							getGameId={() => {return this.state.currentGame.id} }
							stateName="SoccerFootball_highlights_button_guest_penalty"
							autoexpirytime="3"
							/>
						</div>
					</div>

					<div className="row"><div className="col-12 p-0"><hr/></div></div>

					<div className="row">
							<div className="col-12 p-1">
									<div className="form-group">
										<label htmlFor="exampleFormControlTextarea1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_title')}</strong>‚</label>
										<textarea className="form-control" onChange={(e)=>{super.storeOnChangeFormData("_freeText",e)}} value={this.state._freeText} id="exampleFormControlTextarea1" rows="3"></textarea>
									</div>
							</div>
							<div className="col-6 p-1">
									<GpyToggleButton
											title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_button_text')}
											onInit={() => {return {}}}
											onDeactivate={() => {return {visible: false,text:""}}}
											onActivate={() => {return {visible: true,text: this.state._freeText}}}
											scoreboard={this}
											getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
											getGameId={() => {return this.state.currentGame.id} }
											stateName="SoccerFootball_button_freetext"/>
							</div>
							<div className="col-6 p-1">
									 <div className="row"><div className="col-6 pr-0">
													<select style={{padding:"0.25rem 0.5rem",fontSize: "0.875rem",lineHeight:"1.5"}} className="custom-select" value={this.state.crawl_seperator} onChange={(e)=>this.setState({crawl_seperator:e.target.value})} id="inputGroupSelect01">
														 <option selected value={this.state.currentGame.teamMap.HOME_TEAM.logo}>HomeLogo</option>
														 <option value={this.state.currentGame.teamMap.GUEST_TEAM.logo}>GuestLogo</option>
														 <option value={sponsorLogo}>sponsorLogo</option>
														 <option value="point.png">point</option>
														 <option value="star.png">star</option>
														 <option value="empty.png">empty</option>
													</select>
									 </div><div className="col-6 pl-0">
											<GpyToggleButton
													title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_crawl_button_text')}
													onInit={() => {return {}}}
													onDeactivate={() => {return {visible: false,text:""}}}
													onActivate={() => {return {visible: true,text: this.state._freeText,separatorImage:this.state.crawl_seperator!==undefined?this.state.crawl_seperator:this.state.currentGame.teamMap.HOME_TEAM.logo}}}
													scoreboard={this}
													getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
													getGameId={() => {return this.state.currentGame.id} }
													stateName="SoccerFootball_button_freetext_crawl"/>
										</div></div>
							</div>
							</div>


							<div className="row">

								<div className="col-4 p-1">
									<button className="btn btn-light btn-sm  btn-block" onClick={()=>{

										var val = "";

										var playerList = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_PLAYER')).forEach((p)=>{
											var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											playerList.push(name);
										});

										var gplayerList = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_PLAYER')).forEach((p)=>{
											var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											gplayerList.push(name);
										});

										var playerListSub = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_SUBSTITUE')).forEach((p)=>{
											var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											playerListSub.push(name);
										});
										var gplayerListSub = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_SUBSTITUE')).forEach((p)=>{
											var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											gplayerListSub.push(name);
										});
										var coachList = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_COACH')).forEach((p)=>{
										 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
										 coachList.push(name);
										});

										var gcoachList = [];
										this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_COACH')).forEach((p)=>{
										 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
										 gcoachList.push(name);
										});

 										if(playerList.length>0) val = this.state.currentGame.teamMap.HOME_TEAM.name + " Player : " + playerList.join(", ");
										if(playerListSub.length>0) val =  val + "\n" + this.state.currentGame.teamMap.HOME_TEAM.name + " Substitue : " + playerListSub.join(", ");
										if(coachList.length>0) val =  val + "\n" + this.state.currentGame.teamMap.HOME_TEAM.name + " Coach : " + coachList.join(", ");

										if(gplayerList.length>0) val = val + "\n" + this.state.currentGame.teamMap.GUEST_TEAM.name + " Player : " + gplayerList.join(", ");
										if(gplayerListSub.length>0) val =  val + "\n" + this.state.currentGame.teamMap.GUEST_TEAM.name +" Substitue : " + gplayerListSub.join(", ");
										if(gcoachList.length>0) val =  val + "\n" + this.state.currentGame.teamMap.GUEST_TEAM.name + " Coach : " + gcoachList.join(", ");

										super.storeOnChangeFormData("_freeText",{target:{value:val}});
									}}>Gen LineUp</button>
								</div>


								<div className="col-4 p-1">
								<button className="btn btn-light btn-sm  btn-block" onClick={()=>{

									var val = "";
									if(this.state.gamesIsLoaded) {
										this.state.games.Games.Game.forEach((t) => {
											if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {
												val = t.gameName + " (" + moment(t.startTime).locale('de').format('L') + " " + moment(t.startTime).locale(_GPY.locale).format('HH:mm')+" - "+ moment(t.endTime).locale(_GPY.locale).format('HH:mm')+")";
											}
									});
								}
									super.storeOnChangeFormData("_freeText",{target:{value:val}});
								}}>Gen Next Games</button>
								</div>


								<div className="col-4 p-1">
								<button className="btn btn-light btn-sm  btn-block" onClick={()=>{

									var val = "";
									var log = [];

								 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" || e.key.includes("CARD") ).forEach((e) =>  {
						 			 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
						 			 var minI = Math.floor(minF) ;
						 			 var formatMin = ('00'+minI).slice(-2);
									 log.unshift("'"+formatMin + " " + _GPY.i18n.get('gametype_'+this.state.NAME+'_log_key_'+e.key.replace(' ','_')) + " " + e.value);
						 		 });


								 val = log.join("\n");
									super.storeOnChangeFormData("_freeText",{target:{value:val}});
								}}>Gen Highlights</button>
								</div>


					</div>

					<div className="row"><div className="col-12 p-0"><hr/></div></div>

					<div className="row">
					<div className="col-12 p-1"><strong>Log <button title="force reload log" className="btn btn-light btn-sm" onClick={()=>{	this.state.components['gamelog'].tick(); }}><span className="glyphicon glyphicon-refresh" aria-hidden="true"></span></button></strong></div>
					<div className="col-12 p-1" style={{height:"300px",overflowY: "scroll"}}>

							<GpyGameLog stateName="gamelog" scoreboard={this} game={this.state.currentGame} onLoad={ (log) => {
									if(this.state.components['SoccerFootball_score_home'] !== undefined && this.state.components['SoccerFootball_score_guest'] !== undefined){
										this.state.components['SoccerFootball_score_home'].setScore(log.GameLog.elements.filter(e => e.key==="GOAL" && e.team === (""+this.state.currentGame.teamMap.HOME_TEAM.id)).length);
										this.state.components['SoccerFootball_score_guest'].setScore(log.GameLog.elements.filter(e => e.key==="GOAL" && e.team === (""+this.state.currentGame.teamMap.GUEST_TEAM.id)).length);
									}

									this.state.currentGame.players.Player.forEach(p => {
											 p.__events=[];
									});

								 log.GameLog.elements.filter(e => e.key==="YELLOW-RED CARD" ||  e.key==="RED CARD" || e.key==="YELLOW CARD" || e.key==="SUBSTITUTION").forEach((e)=>{
									 var data = JSON.parse(e.data);
									 e.data = data;
									 this.state.currentGame.players.Player.forEach(p => {

										if(e.key==="SUBSTITUTION"){
											if(p.id === data.playerInId || p.id === data.playerOutId ) {
												if(p.__events===undefined){p.__events=[];};
												p.__events.push(data);
											}
										} else {
												if(p.id === data.player.id) {
													if(p.__events===undefined){p.__events=[];};
													p.__events.push(data);
												}
										}
									});
								 });
								 super.refreshPlayerLists();
								}}/>
					</div>
					</div>

				</div>

				<div className="col-12 col-sm-12 col-md col-lg col-xl pl-4">








						<div className="row">
							<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_title')}</strong></div>
							<div className="col-3 p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_small')}
											onInit={() => {return {}}}
											onDeactivate={
												() => {
 													if(this.state.components.SoccerFootball_button_period_1!==undefined && this.state.components.SoccerFootball_button_period_1.isActive()){this.state.components.SoccerFootball_button_period_1.onDeactivate();}
													if(this.state.components.SoccerFootball_button_period_2!==undefined && this.state.components.SoccerFootball_button_period_2.isActive()){this.state.components.SoccerFootball_button_period_2.onDeactivate();}
													if(this.state.components.SoccerFootball_button_period_3!==undefined && this.state.components.SoccerFootball_button_period_3.isActive()){this.state.components.SoccerFootball_button_period_3.onDeactivate();}
													if(this.state.components.SoccerFootball_button_period_4!==undefined && this.state.components.SoccerFootball_button_period_4.isActive()){this.state.components.SoccerFootball_button_period_4.onDeactivate();}
													if(this.state.components.SoccerFootball_button_period_5!==undefined && this.state.components.SoccerFootball_button_period_5.isActive()){this.state.components.SoccerFootball_button_period_5.onDeactivate();}
													return {visible: false}}
											}
											onActivate={() => {
												return {visible: true,
													game : this.state.currentGame,
												  SoccerFootball_score_home: this.state.components.SoccerFootball_score_home!==undefined ? this.state.components.SoccerFootball_score_home.state.score:0,
													sponsorLogo: sponsorLogo,
													SoccerFootball_score_guest:this.state.components.SoccerFootball_score_guest!==undefined ? this.state.components.SoccerFootball_score_guest.state.score:0,}}}
											scoreboard={this}
											getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
											getGameId={() => {return this.state.currentGame.id} }
											stateName="SoccerFootball_button_vs_and_time_mini"
										/>
							</div>
							<div className="col-3 p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_fullscreen')}
											onInit={() => {return {}}}
											onDeactivate={() => {return {visible: false}}}
											onActivate={() => {
												return {visible: true,
													game : this.state.currentGame,
													sponsorLogo: sponsorLogo,
													SoccerFootball_score_home: this.state.components.SoccerFootball_score_home!==undefined ? this.state.components.SoccerFootball_score_home.state.score:0,
													SoccerFootball_score_guest:this.state.components.SoccerFootball_score_guest!==undefined ? this.state.components.SoccerFootball_score_guest.state.score:0,}}}
											scoreboard={this}
											getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
											getGameId={() => {return this.state.currentGame.id} }
											stateName="SoccerFootball_button_vs_and_time_full"
											/>
							</div>
							<div className="col-3 p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_lineup')}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false}}}
										onActivate={() => {
											return {visible: true,
												game : this.state.currentGame}}}
										scoreboard={this}
										getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
										getGameId={() => {return this.state.currentGame.id} }
										stateName="SoccerFootball_button_lineup"
								/>
							</div>

							<div className="col-3 p-1">
							 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_player')}
									 	condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
									 onInit={() => {return {}}}
									 onDeactivate={() => {return {visible: false}}}
									 onActivate={() => {
										 var p = this.state.selectedPlayers[Object.keys(this.state.selectedPlayers)[0]];
										 var log = [];
										 console.log(this.state.components['gamelog'].state.gameLog.GameLog.elements);
										 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.playerId === p.id).forEach((e) =>  {
											 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
											 var minI = Math.floor(minF) ;
											 var formatMin = ('00'+minI).slice(-2);
											 log.push("'"+formatMin + " " + e.key + " " + e.value);
										 });

										 return {visible: true,
											 playerName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
											 playerInfo : p.info!==undefined?p.info.split("\n"):[],
											 playerLog: log,
											 player:p,
											 sponsorLogo: sponsorLogo,
											 team: super.getTeamByPlayer(p),
										 }}}
									 scoreboard={this}
									 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
									 getGameId={() => {return this.state.currentGame.id} }
									 stateName="SoccerFootball_button_playerinfo"
									 autoexpirytime="12"
									 warnOnly="true"
									 />
							</div>

						 </div>



						 <div className="row">
						  <div className="col-3 p-1">
						 	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_hometeam')}
						 				 onInit={() => {return {}}}
						 				 onDeactivate={() => {return {visible: false}}}
						 				 onActivate={() => {
						 					 var playerList = [];
						 					 this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_PLAYER')).forEach((p)=>{
						 						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 playerList.push(name);
						 					 });

											 var playerListSub = [];
						 					 this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_SUBSTITUE')).forEach((p)=>{
						 						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 playerListSub.push(name);
						 					 });

											 var coachList = [];
											 this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_COACH')).forEach((p)=>{
											 	var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											 	coachList.push(name);
											 });

						 					 return {visible: true,
						 						 team : this.state.currentGame.teamMap.HOME_TEAM,
						 						 title: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_hometeam_overlay_title'),
						 						 sponsorLogo: sponsorLogo,
						 						 playerList:playerList,
						 						 substitueList:playerListSub,
												 coachList:coachList,
						 					 }}}
						 				 scoreboard={this}
						 				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 				 getGameId={() => {return this.state.currentGame.id} }
						 				 stateName="SoccerFootball_button_home_team_info"
						 				 autoexpirytime="12"
						 				 warnOnly="true"
						 			 />
						  </div>
						  <div className="col-3 p-1">
						 	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_guestteam')}
						 				 onInit={() => {return {}}}
						 				 onDeactivate={() => {return {visible: false}}}
						 				 onActivate={() => {
						 					 var playerList = [];
						 					 this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_PLAYER')).forEach((p)=>{
						 						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 playerList.push(name);
						 					 });
						 					 var playerListSub = [];
						 					 this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_SUBSTITUE')).forEach((p)=>{
						 						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 playerListSub.push(name);
						 					 });
											 var coachList = [];
											this.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_COACH')).forEach((p)=>{
											 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											 coachList.push(name);
											});
						 					 return {visible: true,
						 						 team: this.state.currentGame.teamMap.GUEST_TEAM,
						 						 title: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_guestteam_overlay_title'),
						 						 sponsorLogo: sponsorLogo,
						 						 playerList:playerList,
						 						 substitueList:playerListSub,
												 coachList:coachList,
						 				 }}}
						 				 scoreboard={this}
						 				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 				 getGameId={() => {return this.state.currentGame.id} }
						 				 stateName="SoccerFootball_button_guest_team_info"
						 				 autoexpirytime="12"
						 				 warnOnly="true"
						 				/>
						  </div>
							<div className="col-3 p-1">
						 	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_coach')}
						 				 condition={() => {return (super.playerCountByRole("HOME_TEAM_COACH,GUEST_TEAM_COACH")===1)}}
										 onInit={() => {return {}}}
						 				 onDeactivate={() => {return {visible: false}}}
						 				 onActivate={() => {
											 var p = this.state.selectedPlayers[Object.keys(this.state.selectedPlayers)[0]];
						 					 return {visible: true,
						 						 team: this.state.currentGame.teamMap.GUEST_TEAM,
						 						 title: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_coach_overlay_title'),
						 						 sponsorLogo: sponsorLogo,
												 coach:p,
												 coachName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
												 coachInfo : p.info!==undefined?p.info.split("\n"):[],
						 				 }}}
						 				 scoreboard={this}
						 				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 				 getGameId={() => {return this.state.currentGame.id} }
						 				 stateName="SoccerFootball_button_coach_info"
						 				 autoexpirytime="15"
						 				/>
						  </div>


							<div className="col-3 p-1">
						 	 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_referee')}
						 				 condition={() => {return (this.state.currentGame.referees!==undefined&&this.state.currentGame.referees.Referee!==undefined&&this.state.currentGame.referees.Referee.length > 0)}}
										 onInit={() => {return {}}}
						 				 onDeactivate={() => {return {visible: false}}}
						 				 onActivate={() => {
						 					 var referees = [];
						 					 this.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_MAIN').forEach((p)=>{
						 						 	var name = _GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_MAIN') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 	referees.push(name);
						 					 });
						 					 this.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_ASSISTANT').forEach((p)=>{
						 						 	var name = _GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_ASSISTANT') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 						 	referees.push(name);
						 					 });
											this.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_FOURTH').forEach((p)=>{
											 		var name = _GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_FOURTH') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											 		referees.push(name);
											});
											this.state.currentGame.referees.Referee.filter(p => p.vsRole === 'REFEREE_FIFTH').forEach((p)=>{
											 		var name = _GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_FIFTH') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
											 		referees.push(name);
											});
						 					return {visible: true,
						 						 team: this.state.currentGame.teamMap.GUEST_TEAM,
						 						 title: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_referee_overlay_title'),
						 						 sponsorLogo: sponsorLogo,
						 						 refereeList:referees,
						 				 }}}
						 				 scoreboard={this}
						 				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 				 getGameId={() => {return this.state.currentGame.id} }
						 				 stateName="SoccerFootball_button_referee_info"
						 				 autoexpirytime="15"
										 warnOnly="true"
						 				/>
						  </div>


							<div className="col-3 p-1">
							 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_crew')}
										 condition={() => {return (this.state.currentGame.crews!==undefined&&this.state.currentGame.crews.Crew!==undefined&&this.state.currentGame.crews.Crew.length > 0)}}
										 onInit={() => {return {}}}
										 onDeactivate={() => {return {visible: false}}}
										 onActivate={() => {
											 var crews = [];
											 this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_COMMENTATOR').forEach((p)=>{
													var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_COMMENTATOR') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													crews.push(name);
											 });
											 this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_STREAMING_OPERATOR').forEach((p)=>{
													 var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_STREAMING_OPERATOR') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													 crews.push(name);
											 });
											 this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_CAMERA_OPERATOR').forEach((p)=>{
													var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_CAMERA_OPERATOR') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													crews.push(name);
											 });
											this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_SOUND_TECHNICIAN').forEach((p)=>{
													var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_SOUND_TECHNICIAN') + "#TAB#" + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													crews.push(name);
											});
											this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_GRAPHIC').forEach((p)=>{
													var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_GRAPHIC') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													crews.push(name);
											});
											this.state.currentGame.crews.Crew.filter(p => p.vsRole === 'CREW_ASSISTANT').forEach((p)=>{
													var name = _GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_ASSISTANT') + "#TAB#" +  (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
													crews.push(name);
											});
											return {visible: true,
												 title: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_info_button_crew_overlay_title'),
												 sponsorLogo: sponsorLogo,
												 crewList:crews,
										 }}}
										 scoreboard={this}
										 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
										 getGameId={() => {return this.state.currentGame.id} }
										 stateName="SoccerFootball_button_crew_info"
										 autoexpirytime="15"
										 warnOnly="true"
										/>
							</div>


						 </div>



						 <div className="row">
						 	<div className="col-12 p-1"><strong>Periods</strong></div>
						 	<div className="col-3 p-1">
						 		<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_1')}
						 			onDeactivate={() => {return {visible: false}}}
						 			onActivate={() => {return {visible: true, type:"PERIOD", message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_1')}}}
						 			scoreboard={this}
						 			getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 			getGameId={() => {return this.state.currentGame.id} }
						 			stateName="SoccerFootball_button_period_1" />
						 	</div>

						 	<div className="col-3 p-1">
						 	<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_2')}
						 		onDeactivate={() => {return {visible: false}}}
						 		onActivate={() => {return {visible: true, type:"PERIOD", message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_2')}}}
						 		scoreboard={this}
						 		getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 		getGameId={() => {return this.state.currentGame.id} }
						 		stateName="SoccerFootball_button_period_2"  />
						 	</div>

						 	<div className="col-3 p-1">
						 	<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_3')}
						 		onDeactivate={() => {return {visible: false}}}
						 		onActivate={() => {return {visible: true, type:"PERIOD", message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_3')}}}
						 		scoreboard={this}
						 		getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 		getGameId={() => {return this.state.currentGame.id} }
						 		stateName="SoccerFootball_button_period_3"  />
						 	</div>

						 	<div className="col-3 p-1">
						 	<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_4')}
						 		onDeactivate={() => {return {visible: false}}}
						 		onActivate={() => {return {visible: true, type:"PERIOD",message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_4')}}}
						 		scoreboard={this}
						 		getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 		getGameId={() => {return this.state.currentGame.id} }
						 		stateName="SoccerFootball_button_period_4"  />
						 	</div>

							 </div>
							 <div className="row">

						 	<div className="col-3 p-1">
						 	<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_5')}
						 		onDeactivate={() => {return {visible: false}}}
						 		onActivate={() => {return {visible: true, type:"PERIOD", message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_message_periods_5')}}}
						 		scoreboard={this}
						 		getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						 		getGameId={() => {return this.state.currentGame.id} }
						 		stateName="SoccerFootball_button_period_5"  />
						 	</div>

						 </div>












						 <div className="row">
						 			<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_title')}</strong></div>
								 <div className="col-6 p-1">
									 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_button_stats')}

											 onInit={() => {return {}}}
											 onDeactivate={() => {return {visible: false}}}
											 onActivate={() => {
												 var homeGameLog = [];
												 var guestGameLog = [];

												 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && e.team === (""+this.state.currentGame.teamMap.HOME_TEAM.id)).forEach((e) =>  {
													 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
													 var minI = Math.floor(minF) ;
													 var formatMin = ('00'+minI).slice(-2);
													 homeGameLog.unshift("'"+formatMin + " " + e.key + " " + e.value);
												 });

												 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && (""+this.state.currentGame.teamMap.GUEST_TEAM.id)===e.team).forEach((e) =>  {
													 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
													 var minI = Math.floor(minF) ;
													 var formatMin = ('00'+minI).slice(-2);
													 guestGameLog.unshift("'"+formatMin + " " + e.key + " " + e.value);
												 });

												 return {
													 visible: true,
													 guest_score: guestGameLog.length,
													 home_score: homeGameLog.length,
													 home_gameLog: homeGameLog,
													 guest_gameLog: guestGameLog,

													 game: this.state.currentGame,
													 sponsorLogo: sponsorLogo,
												 }}}
											 scoreboard={this}
											 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
											 getGameId={() => {return this.state.currentGame.id} }
											 stateName="SoccerFootball_button_goal_statistics"
											 />
								 </div>
								 <div className="col-6 p-1">
									 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_button_fullstats')}
										 onInit={() => {return {}}}
										 onDeactivate={() => {return {visible: false}}}
										 onActivate={() => {
											 var home_card_Log = [];
											 var guest_card_Log = [];

											 var home_highlight_Log = [];
											 var guest_highlight_Log = [];

											 var home_goal_Log = [];
											 var guest_goal_Log = [];


											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && e.team === (""+this.state.currentGame.teamMap.HOME_TEAM.id)).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 home_goal_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });

											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && (""+this.state.currentGame.teamMap.GUEST_TEAM.id)===e.team).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 guest_goal_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });


											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key.includes("CARD") && e.team === (""+this.state.currentGame.teamMap.HOME_TEAM.id)).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 home_card_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });

											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key.includes("CARD") && (""+this.state.currentGame.teamMap.GUEST_TEAM.id)===e.team).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 guest_card_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });

											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e =>  (!e.key.includes("CARD") && e.key!=="GOAL") &&  e.team === (""+this.state.currentGame.teamMap.HOME_TEAM.id)).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 home_highlight_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });

											 this.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e =>  (!e.key.includes("CARD") && e.key!=="GOAL") &&  (""+this.state.currentGame.teamMap.GUEST_TEAM.id)===e.team).forEach((e) =>  {
												 var minF = (parseInt(e.timerOffset)/1000) / 60 ;
												 var minI = Math.floor(minF) ;
												 var formatMin = ('00'+minI).slice(-2);
												 guest_highlight_Log.unshift("'"+formatMin + " " + e.key + " " + e.value);
											 });

											 home_goal_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_goals_title'),"");
											 guest_goal_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_goals_title'),"");

											 home_card_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_card_title'),"");
											 guest_card_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_card_title'),"");

											 home_highlight_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_highlight_title'),"");
											 guest_highlight_Log.unshift(_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_stats_fullstats_highlight_title'),"");

											 return {
												 visible: true,
												 guest_score: guest_goal_Log.length-2,
												 home_score: home_goal_Log.length-2,

												 home_goal_log: home_goal_Log,
												 guest_goal_log: guest_goal_Log,

												 home_card_log: home_card_Log,
												 guest_card_log: guest_card_Log,

												 home_highlight_log: home_highlight_Log,
												 guest_highlight_log: guest_highlight_Log,

												 game: this.state.currentGame,
												 sponsorLogo: sponsorLogo,
											 }}}
										 scoreboard={this}
										 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
										 getGameId={() => {return this.state.currentGame.id} }
										 stateName="SoccerFootball_button_full_statistics"
										  />
									 </div>
						 </div>



							<div className="row">

							<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_title')}</strong></div>
						  <div className="col-12 p-1"><GpyTime stateName="SoccerFootball_gameclock" scoreboard={this}/></div>

{this.state.components.SoccerFootball_gameclock===undefined?"":this.state.components.SoccerFootball_gameclock.state.activeTimer?
									<div className="col-12 p-1"><button onClick={()=>{super.onPlayTime("SoccerFootball_gameclock","stop")}} className="btn btn-secondary btn-sm btn-block"><span className="glyphicon glyphicon-stop" /> {_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_button_stop')}</button></div>
:
									<div className="col-12 p-1"><button onClick={()=>{super.onPlayTime("SoccerFootball_gameclock","start")}} className="btn btn-secondary btn-sm btn-block"><span className="glyphicon glyphicon-play" /> {_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_button_start')}</button></div>
}
							</div>

{this.state.components.SoccerFootball_gameclock!==undefined && this.state.components.SoccerFootball_gameclock.state.activeTimer?"":<div className="row">

																<div className="col-4 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_gameclock",0)}} className="btn btn-secondary  btn-sm btn-block">00:00</button></div>
																<div className="col-4 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_gameclock",(45*60*1000))}} className="btn btn-secondary btn-sm btn-block">45:00</button></div>
																<div className="col-4 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_gameclock",(90*60*1000))}} className="btn btn-secondary btn-sm btn-block">90:00</button></div>

																<div className="col-4 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_gameclock",(105*60*1000))}} className="btn btn-secondary btn-sm btn-block">105:00</button></div>
																<div className="col-4 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_gameclock",(120*60*1000))}} className="btn btn-secondary btn-sm btn-block">120:00</button></div>
																<div className="col-4 p-1"><button className="btn btn-secondary btn-sm btn-block">{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_button_extraTime')}</button></div>

</div>}



<div className="row">
		<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_countdown_title')}</strong></div>
		<div className="col-sm-6 col-md-12 col-lg-12 col-xl-6 p-1"><GpyTime stateName="SoccerFootball_countdown" countdown="true" scoreboard={this}/></div>

		<div className="col-sm-2 col-md-4 col-lg-4 col-xl-2 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_countdown",(5*60*1000))}} className="btn btn-secondary btn-sm btn-block">05:00</button></div>
		<div className="col-sm-2 col-md-4 col-lg-4 col-xl-2 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_countdown",(10*60*1000))}} className="btn btn-secondary btn-sm btn-block">10:00</button></div>
		<div className="col-sm-2 col-md-4 col-lg-4 col-xl-2 p-1"><button onClick={()=>{super.setGameTime("SoccerFootball_countdown",(15*60*1000))}} className="btn btn-secondary btn-sm btn-block">15:00</button></div>

{this.state.components.SoccerFootball_countdown===undefined?"":this.state.components.SoccerFootball_countdown.state.activeTimer?
		<div className="col-6 p-1"><button onClick={()=>{super.onPlayTime("SoccerFootball_countdown","stop")}} className="btn btn-secondary btn-sm btn-block"><span className="glyphicon glyphicon-stop" /> {_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_button_stop')}</button></div>
:
		<div className="col-6 p-1"><button onClick={()=>{super.onPlayTime("SoccerFootball_countdown","start")}} className="btn btn-secondary btn-sm btn-block"><span className="glyphicon glyphicon-play" /> {_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_gameclock_button_start')}</button></div>
}
		<div className="col-6 p-1">
				<GpyToggleButton
						title="Cowndown"
						onInit={() => {return {}}}
						onDeactivate={() => {return {visible: false}}}
						onActivate={() => {
							return {visible: true,type:"Cowndown"}
						}}
						scoreboard={this}
						getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
						getGameId={() => {return this.state.currentGame.id} }
						warnOnly="true"
						stateName="SoccerFootball_button_countdown"/>
		</div>
</div>



							<div className="row">
							  <div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_title')} {super.playerCountByRole("HOME_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_PLAYER,GUEST_TEAM_SUBSTITUE")}</strong></div>
								<div className="col-12 p-1">
										<GpyToggleButton
										 condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_PLAYER,GUEST_TEAM_SUBSTITUE") === 2 )}}
													title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_button_substitution')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													var pout = super.getHomeOrGuestPlayer();
													var pin = super.getHomeOrGuestSubstitutionPlayer();

													pin.vsRole = pin.vsRole.replace("_SUBSTITUE","_PLAYER");
													pout.vsRole = pout.vsRole.replace("_PLAYER","_SUBSTITUE");

													super.unselectPlayertLists();

												  super.refreshPlayerLists();
													//super.selectPlayerById(pin);
													//super.selectPlayerById(pout);

													var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
													var minF = (m/1000) / 60 ;
													var min = Math.floor(minF) ;
													var formatMin = "'"+('00'+min).slice(-2);

													__GPYPost("updatePlayerVsRole",{ gameId : this.state.currentGame.id , players : [pin,pout] } );

													var res = {visible: true,type:"SUBSTITUTION",
														team: super.getTeamByPlayer(pin),
														playerIn : (pin.firstName!==undefined && pin.firstName!==''? pin.firstName +" ":"") + (pin.lastName!==undefined&&pin.lastName!==''?pin.lastName:"") ,
														playerOut : (pout.firstName!==undefined && pout.firstName!==''? pout.firstName +" ":"") + (pout.lastName!==undefined&&pout.lastName!==''?pout.lastName:"") ,
														playerInFullName: _GPY.toPlayerName(pin),
														playerOutFullName: _GPY.toPlayerName(pout),

														playerInId : pin.id ,
														playerOutId : pout.id ,
														minute : formatMin,
													}
													if(pin.__events===undefined){pin.__events=[];}
													pin.__events.push(res);
													if(pout.__events===undefined){pout.__events=[];}
													pout.__events.push(res);
													super.refreshPlayerLists();

													return res;
												}}
												scoreboard={this}
												getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
												getGameId={() => {return this.state.currentGame.id} }
												autoexpirytime="15"
												stateName="SoccerFootball_button_substitution" />
									</div>
							</div>
							<div className="row">
									<div className="col-4 p-1">
										<GpyToggleButton
												condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER")===1)}}
												title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_button_yellow')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													var p = super.getHomeOrGuestPlayer();
													var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
													var minF = (m/1000) / 60 ;
													var min = Math.floor(minF) ;
													var formatMin = "'"+('00'+min).slice(-2);

													var res = { visible: true, type:"YELLOW CARD",
														player: p,
														playerFullName: _GPY.toPlayerName(p),
														team: super.getTeamByPlayer(p),
														message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_message_yellow'),
														icon: "SoccerFootball/card_yellow.png",
														minute : formatMin,
													};
													if(p.__events===undefined){p.__events=[];}
													p.__events.push(res);
													super.refreshPlayerLists();
													return res;
												}}
												scoreboard={this}
												getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
												getGameId={() => {return this.state.currentGame.id} }
												autoexpirytime="15"
												stateName="SoccerFootball_button_card_yellow"/>
									</div>
									<div className="col-4 p-1">
									  <GpyToggleButton
											condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER")===1)}}
												title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_button_yellow_red')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													var p = super.getHomeOrGuestPlayer();
													var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
													var minF = (m/1000) / 60 ;
													var min = Math.floor(minF) ;
													var formatMin = "'"+('00'+min).slice(-2);

													var res = {visible: true,type:"YELLOW-RED CARD",
														player: p,
														playerFullName: _GPY.toPlayerName(p),
														team: super.getTeamByPlayer(p),
														message:  _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_message_yellow_red'),
														icon: "SoccerFootball/card_yellow_red.png",
														minute: formatMin
													};
														if(p.__events===undefined){p.__events=[];}
														p.__events.push(res);
														super.refreshPlayerLists();
														return res;
													}}
												autoexpirytime="15"
												scoreboard={this}
												getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="SoccerFootball_button_card_yellowred"/>
									</div>

									<div className="col-4 p-1">
										<GpyToggleButton
													condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER")===1)}}
												title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_button_red')}
												onInit={() => {return {}}}
												onDeactivate={() => {
													return {visible: false}}}
												onActivate={() => {
													var p = super.getHomeOrGuestPlayer();
													var m = this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0;
													var minF = (m/1000) / 60 ;
													var min = Math.floor(minF) ;
													var formatMin = "'"+('00'+min).slice(-2);

													var res ={visible: true, type:"RED CARD",
														player: p,
														playerFullName: _GPY.toPlayerName(p),
														team: super.getTeamByPlayer(p),
														message: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_substitution_card_message_red'),
														icon: "SoccerFootball/card_red.png",
														minute: formatMin
													};
														if(p.__events===undefined){p.__events=[];}
														p.__events.push(res);
														super.refreshPlayerLists();
														return res;
												}}
												autoexpirytime="15"
												scoreboard={this}
												getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="SoccerFootball_button_card_red"/></div>
							</div>



							<div className="row">
								<div className="col-12 p-1">
									<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_advertisement_title')}</strong>
								</div>

								{this.state.advertisementsIsLoaded ? this.state.advertisements.Advertisements.Advertisement.map((t) =>
									<div key={t.id} className="col-4 p-1">
									<GpyToggleButton
											key={t.id}
											title={t.name}
											onInit={() => {return {}}}
											onDeactivate={() => {return {visible: false,text:""}}}
											onActivate={() => {return {visible: true,advertisement:t}}}
											scoreboard={this}
											getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
											getGameId={() => {return this.state.currentGame.id} }
											stateName="any_button_advertisement"/>
									</div>
								) :  <WaitCube/>  }


							</div>


				</div>




				<div className="col-12 col-sm-12 col-md-12 col-lg col-xl">

					<div className="row">
						<div className="col p-1">
								<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_home_title')}</strong>
								<GpyTeamList scoreboard={this} exclusionRoles="GUEST_TEAM_PLAYER,GUEST_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="HOME_TEAM_PLAYER" stateName="SoccerFootball_teamlist_home_player"/>
						</div>
						<div className="col p-1">
								<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_guest_title')}</strong>
								<GpyTeamList scoreboard={this} exclusionRoles="HOME_TEAM_PLAYER,HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GUEST_TEAM_PLAYER" stateName="SoccerFootball_teamlist_guest_player"/>
						</div>
					</div>

					<div className="row">
						<div className="col-12 p-1">
							<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_substitue_title')}</strong>
						</div>
						<div className="col p-1">
								<GpyTeamList scoreboard={this} color="warning" exclusionRoles="GUEST_TEAM_PLAYER,GUEST_TEAM_SUBSTITUE"  game={this.state.currentGame} vsRole="HOME_TEAM_SUBSTITUE" stateName="SoccerFootball_teamlist_home_substitue"/>
						</div>
						<div className="col p-1">
								<GpyTeamList scoreboard={this} color="warning" exclusionRoles="HOME_TEAM_PLAYER,HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GUEST_TEAM_SUBSTITUE" stateName="SoccerFootball_teamlist_guest_substitue"/>
						</div>
					</div>

					<div className="row">
						<div className="col-12 p-1">
							<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_coach_title')}</strong>
						</div>
						<div className="col p-1">
								<GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="GUEST_TEAM_COACH"game={this.state.currentGame} vsRole="HOME_TEAM_COACH" stateName="SoccerFootball_teamlist_home_coach"/>
						</div>
						<div className="col p-1">
								<GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="HOME_TEAM_COACH" game={this.state.currentGame} vsRole="GUEST_TEAM_COACH" stateName="SoccerFootball_teamlist_guest_coach"/>
						</div>
					</div>



{_GPY.uiStates.userLvl < _GPY.USER_PRO ?
					<div className="row">
						<div className="col-8 text-right pt-5">
						    <button onClick={()=>{super.setGameType("UserSubscription")}} className="btn btn-link p-0 pl-1"><img style={{maxHeight : '50px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="Guppyi"/></button>
						</div>
						<div className="col-4 text-left pt-5">
								<button onClick={()=>{super.setGameType("UserSubscription")}} className="btn btn-link p-0 pl-1"><img style={{maxHeight : '60px'}} src={_GPY.resource("images/gopro.gif")} className="img-fluid" alt="Guppyi"/></button>
						</div>
						<div className="col-12 text-center">
								<a href={"https://www.guppyi.com/prices/?lang="+_GPY.locale}  rel="noopener noreferrer"  target="_blank">{_GPY.i18n.get('UserSubscription_userwarn_subscription_infomation_link')}</a>
						</div>
					</div>
:""}
				</div>
			</div>
			:<div>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_warn_message_selectgame')}</div>}
			</div>
	);
    }

}
export default SBSoccerFootball;
